// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #FFFFFF;
  --white-secondary: #f4f4f4;
  --black: #000000;
  --bluee: #282c34;
  --lightblue: #61dafb;
  --lightgray: #eff0f1;
  ---gray100: #f3f4f6;
  --gray200: #dfe2e5;
  --gray300: #d1d5db;
  --gray400: #d3d3d3;
  --gray500: #6a737d;
  --gray600: #69788B;
  --gray700: #374151;
}

.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--gray300);
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Loader/index.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;ACCJ;;AAXA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AAcF","sourcesContent":[":root {\n    --white: #FFFFFF;\n    --white-secondary: #f4f4f4;\n    --black: #000000;\n    --bluee: #282c34;\n    --lightblue: #61dafb;\n    --lightgray: #eff0f1;\n    ---gray100: #f3f4f6;\n    --gray200: #dfe2e5;\n    --gray300: #d1d5db;\n    --gray400: #d3d3d3;\n    --gray500: #6a737d;\n    --gray600: #69788B;\n    --gray700: #374151;\n\n}\n","\n          @import \"@assets/styles/_variables.scss\";\n        \n.overlay{\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--gray300);\n  z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
